import { render, staticRenderFns } from "./AdminCreateCouponDialog.vue?vue&type=template&id=f3b6bdc2&"
import script from "./AdminCreateCouponDialog.vue?vue&type=script&lang=ts&"
export * from "./AdminCreateCouponDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports